import { lambdaComparator, localeComparator, sortBy } from '@fifa-bsm/bo-frontend-shared/utils';
import { TicketListSortType } from '@/app/modules/seating/guestOperations/Picker/domain/enums/TicketListSortType';
import { SortDirection } from '@/app/shared/constants/sortDirection';

export const sortTicketsTree = (tree, by) => {
    const sort = (comparator) => sortBy(comparator, tree);

    if (by === TicketListSortType.LAST_NAME_ASC || by === TicketListSortType.LAST_NAME_DESC) {
        return sort(
            localeComparator(
                (item) => item.guest.family_name.toLocaleLowerCase(),
                by === TicketListSortType.LAST_NAME_ASC ? SortDirection.ASC : SortDirection.DESC
            )
        );
    }

    if (
        by === TicketListSortType.NUMBER_OF_TICKETS_ASC ||
        by === TicketListSortType.NUMBER_OF_TICKETS_DESC
    ) {
        return sort(
            lambdaComparator(
                (item) => 1 + item.nestedTickets.length,
                by === TicketListSortType.NUMBER_OF_TICKETS_ASC
                    ? SortDirection.ASC
                    : SortDirection.DESC
            )
        );
    }

    if (by === TicketListSortType.ROLE) {
        return sort(localeComparator((item) => (item.guest.role ?? '').toLocaleLowerCase()));
    }

    if (by === TicketListSortType.PARTICIPANT_GROUP) {
        return sort(
            localeComparator((item) =>
                (item.guest.participant_group?.path ?? '').toLocaleLowerCase()
            )
        );
    }

    throw new Error(`Unexpected "sortBy" value passed. Got \`${by}\`.`);
};
